import {
  ATTENDANTS_RECIEVED,
  BAR_DATA_RECIEVED,
  CALENDAR_RECIEVED,
  CHANGE_FILTER_PLACE,
  CHANGE_FILTER_SEARCH_OPTION,
  CHANGE_FILTER_STATE,
  CHANGE_SERVICE_PLACE,
  FILTER_PLACES_SENT,
  GET_ATTENDANTS,
  GET_BAR_DATA,
  GET_CALENDAR_DATA,
  GET_PIE_DATA,
  GET_PLACES,
  GET_QUEUE,
  GET_SERVICES,
  PIE_DATA_RECIEVED,
  PLACES_RECIEVED,
  QUEUE_INITIAL_RECIEVED,
  QUEUE_RECIEVED,
  SERVICES_RECIEVED,
  UPDATE_FILTER_SEARCH_QUERY,
  UPDATE_SELECTED_CALENDAR
} from "./../actions/types";

import { filterState } from "./../assets/filterState";

const initialState = {
  attendants: [],
  calendar: {},
  services: [],
  queue: [],
  places: [],
  pieData: [],
  barData: [],
  filterSearchOption: "id",
  filterSearchQuery: "",
  filterState,
  filterPlace: [],
  filterStateActive: "Todos",
  filterPlaceActive: "Todos",
  filterServiceActive: "Todos",
  selectedCalendar: "STI",
  loadingAttendants: true,
  loadingPlaces: true,
  loadingQueue: true,
  loadingServices: true,
  loadingPieData: true,
  loadingBarData: true,
  loadingCalendarData: true
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ATTENDANTS:
      return {
        ...state,
        loadingAttendants: true
      };
    case GET_PLACES:
      return {
        ...state,
        loadingPlaces: true
      };
    case GET_QUEUE:
      return {
        ...state,
        loadingQueue: true
      };
    case GET_SERVICES:
      return {
        ...state,
        loadingServices: true
      };
    case GET_BAR_DATA:
      return {
        ...state,
        loadingBarData: true
      };
    case GET_PIE_DATA:
      return {
        ...state,
        loadingPieData: true
      };
    case GET_CALENDAR_DATA:
      return {
        ...state,
        loadingCalendarData: true
      };
    case ATTENDANTS_RECIEVED:
      return {
        ...state,
        loadingAttendants: false,
        attendants: action.data
      };
    case PLACES_RECIEVED:
      return {
        ...state,
        loadingPlaces: false,
        places: action.data
      };
    case FILTER_PLACES_SENT:
      return {
        ...state,
        filterPlace: action.data
      };
    case QUEUE_INITIAL_RECIEVED:
      return {
        ...state,
        loadingQueue: false,
        queue: action.data
      };
    case QUEUE_RECIEVED:
      return {
        ...state,
        loadingQueue: false,
        queue: action.data
      };
    case SERVICES_RECIEVED:
      return {
        ...state,
        loadingServices: false,
        services: action.data
      };
    case BAR_DATA_RECIEVED:
      return {
        ...state,
        loadingBarData: false,
        barData: action.data
      };
    case PIE_DATA_RECIEVED:
      return {
        ...state,
        loadingPieData: false,
        pieData: action.data
      };
    case CALENDAR_RECIEVED:
      return {
        ...state,
        loadingCalendarData: false,
        calendar: action.data
      };
    case CHANGE_FILTER_SEARCH_OPTION:
      return {
        ...state,
        filterSearchOption: action.payload
      };
    case CHANGE_FILTER_PLACE:
      return {
        ...state,
        filterPlaceActive: action.payload
      };
    case CHANGE_FILTER_STATE:
      return {
        ...state,
        filterStateActive: action.payload
      };
    case CHANGE_SERVICE_PLACE:
      return {
        ...state,
        filterServiceActive: action.payload
      };
    case UPDATE_FILTER_SEARCH_QUERY:
      return {
        ...state,
        filterSearchQuery: action.payload
      };
    case UPDATE_SELECTED_CALENDAR:
      return {
        ...state,
        selectedCalendar: action.payload
      };
    default:
      return state;
  }
}
